import type { ICustomControlData } from './customControlData';
import { decodeHolterMedications } from '../../../../../../common/customControls/holterIndicationsAndMedications';
import { FormLabel } from '../../../../elements/forms/FormLabel';
import { HorizontalFormGroupRead } from '../../../../elements/forms/horizontalFormGroupRead/HorizontalFormGroupRead';
import { InputContainer } from '../../../../elements/forms/InputContainer';
import { List } from '../../../../elements/List/List';

interface IMedicatieReadProps {
    customControlData: ICustomControlData;
}

export function MedicatieRead(props: IMedicatieReadProps) {
    if (
        !(
            props.customControlData.medicatie.geenMedicatie ||
            props.customControlData.medicatie.antiStolling ||
            props.customControlData.medicatie.geenCardialeMedicatie ||
            props.customControlData.medicatie.aceRemmer ||
            props.customControlData.medicatie.antiAritmica ||
            props.customControlData.medicatie.calciumantagonist ||
            props.customControlData.medicatie.digitalis ||
            props.customControlData.medicatie.nitraten ||
            props.customControlData.medicatie.betaBlokker ||
            props.customControlData.medicatie.antiHypertensiva ||
            props.customControlData.medicatie.diuretica ||
            props.customControlData.medicatie.andersText
        )
    ) {
        return null;
    }

    return (
        <HorizontalFormGroupRead>
            <FormLabel>Medicatie</FormLabel>
            <InputContainer>
                <List
                    bold
                    items={decodeHolterMedications(props.customControlData)}
                />
            </InputContainer>
        </HorizontalFormGroupRead>
    );
}
